/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatKg } from './constants';

const headerCellSx = {
  fontWeight: 700,
  bgcolor: 'action.hover',
  borderBottom: 2,
  borderColor: 'divider',
  py: 1.25,
  px: 1.5,
  fontSize: '0.8125rem',
  whiteSpace: 'nowrap',
};

const numericSx = {
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
};

const MalhaSummaryTable = ({ items, loading, selectedMalhaId, onMalhaSelect }) => {
  if (loading) {
    return (
      <Paper variant="outlined" sx={{ borderRadius: 2, p: 2 }}>
        <Skeleton variant="rectangular" height={240} sx={{ borderRadius: 1 }} />
      </Paper>
    );
  }

  if (!items?.length) {
    return (
      <Paper variant="outlined" sx={{ borderRadius: 2, p: 4, textAlign: 'center', color: 'text.secondary' }}>
        <Typography variant="body2">Nenhum dado por malha no período.</Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellSx}>Malha</TableCell>
              <TableCell sx={{ ...headerCellSx, ...numericSx }}>NSIRs</TableCell>
              <TableCell sx={{ ...headerCellSx, ...numericSx }}>Em Inspeção</TableCell>
              <TableCell sx={{ ...headerCellSx, ...numericSx }}>Em Digitação</TableCell>
              <TableCell sx={{ ...headerCellSx, ...numericSx }}>Finalizadas</TableCell>
              <TableCell sx={{ ...headerCellSx, ...numericSx }}>Total kg</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => {
              const isSelected = selectedMalhaId === item.malhaId;
              return (
                <TableRow
                  key={item.malhaId}
                  hover
                  selected={isSelected}
                  onClick={() => onMalhaSelect?.(isSelected ? null : item)}
                  sx={{ cursor: onMalhaSelect ? 'pointer' : 'default' }}
                >
                  <TableCell sx={{ fontWeight: 600 }}>
                    {item.malhaCodigo || '—'}
                    {item.malhaNome ? (
                      <Typography variant="caption" color="text.secondary" display="block">
                        {item.malhaNome}
                      </Typography>
                    ) : null}
                  </TableCell>
                  <TableCell sx={numericSx}>{item.nsirs ?? 0}</TableCell>
                  <TableCell sx={numericSx}>{item.emInspecao ?? 0}</TableCell>
                  <TableCell sx={numericSx}>{item.emDigitacao ?? 0}</TableCell>
                  <TableCell sx={numericSx}>{item.finalizadas ?? 0}</TableCell>
                  <TableCell sx={{ ...numericSx, fontWeight: 700 }}>{formatKg(item.totalKg)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

MalhaSummaryTable.propTypes = {
  items: PropTypes.array,
  loading: PropTypes.bool,
  selectedMalhaId: PropTypes.number,
  onMalhaSelect: PropTypes.func,
};

MalhaSummaryTable.defaultProps = {
  items: [],
  loading: false,
  selectedMalhaId: null,
  onMalhaSelect: null,
};

export default MalhaSummaryTable;
